import React from 'react';
import LocationTemplate from './LocationTemplate';

const HollySpringPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Holly Springs"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27540"]}
      latitude={35.6513}
      longitude={-78.8336}
      population={42915}
      historicalFact="Named for the springs surrounded by holly trees that attracted early settlers in the 1750s."
      nearbyTowns={[
        "Apex, NC",
        "Cary, NC",
        "Fuquay-Varina, NC",
        "Raleigh, NC",
        "Morrisville, NC",
        "Garner, NC",
        "Clayton, NC",
        "Durham, NC"
      ]}
    />
  );
};

export default HollySpringPage;